
const apiPrefix = "/api";
const apiPrefixAuthentication = "authentication";
const apiPrefixCareRecipient = "care_recipient";
const apiPrefixCareComment = "care_comment";
const apiPrefixCareCommentThread = "care_comment_thread";
const apiPrefixCareRecipientMemo = "care_recipient_memo";
const apiPrefixAssessment = "assessment";
const apiPrefixInformation = "information";
const apiPrefixFAQ = "faq";
const apiPrefixDetection = "detection";
const apiPrefixReport = "report";
const apiPrefixDiseaseKnowledge = "disease_knowledge";
const apiPrefixServiceProvider = "service_provider";
const apiPrefixUser = "user";
const apiPrefixUtilizationDocument = "utilization_document";
const apiPrefixAdmin = "admin";
export const ApiPaths = {
    authentication: {
        user: `${apiPrefix}/${apiPrefixAuthentication}/user`,
    },
    careRecipient: {
        // 利用者リスト取得
        list: `${apiPrefix}/${apiPrefixCareRecipient}/list`,
        // 利用者情報取得
        information: `${apiPrefix}/${apiPrefixCareRecipient}`,
    },
    assessment: {
        // お知らせ
        info: `${apiPrefix}/${apiPrefixAssessment}/info`,
        schedule: `${apiPrefix}/${apiPrefixAssessment}/schedule`
    },
    information: {
        // お知らせ
        list: `${apiPrefix}/${apiPrefixInformation}/list`,
        info: `${apiPrefix}/${apiPrefixInformation}/{informationId}`
    },
    faq: {
        // FAQ
        list: `${apiPrefix}/${apiPrefixFAQ}/list`
    },
    careComment: {
        // ケアコメント
        list: `${apiPrefix}/${apiPrefixCareComment}/list`,
        markAsRead: `${apiPrefix}/${apiPrefixCareComment}/mark_as_read`,
        pin: `${apiPrefix}/${apiPrefixCareComment}/pin`
    },
    careCommentThread: {
        // ケアコメントスレッド
        list: `${apiPrefix}/${apiPrefixCareCommentThread}/list`
    },
    detection: {
        // 通知設定
        config: `${apiPrefix}/${apiPrefixDetection}/config`,
        threshold: `${apiPrefix}/${apiPrefixDetection}/threshold`,
        list: `${apiPrefix}/${apiPrefixDetection}/list`
    },
    report: {
        dailyComments: `${apiPrefix}/${apiPrefixReport}/daily_comments/list`,
        monthlyComments: `${apiPrefix}/${apiPrefixReport}/monthly_comments/list`,
        monthlyData: `${apiPrefix}/${apiPrefixReport}/monthly_average`,
        dailyEstimatedBehaviors: `${apiPrefix}/${apiPrefixReport}/estimated_behavior`,
        careRecipientLatestInfo: `${apiPrefix}/${apiPrefixReport}/care_recipient_latest_info`,
        estimatedBehaviorHistories: `${apiPrefix}/${apiPrefixReport}/estimated_behavior/history/{careRecipientId}`,
        estimatedBehaviorAverages: `${apiPrefix}/${apiPrefixReport}/estimated_behavior/average/{careRecipientId}`,
        estimatedBehaviorAlertPeriod: `${apiPrefix}/${apiPrefixReport}/alert/period/{careRecipientId}`,
        estimatedBehaviorAlert: `${apiPrefix}/${apiPrefixReport}/alert/{careRecipientId}`,
    },
    diseaseKnowledge: {
        info: `${apiPrefix}/${apiPrefixDiseaseKnowledge}`,
        list: `${apiPrefix}/${apiPrefixDiseaseKnowledge}/list`,
        lookup: `${apiPrefix}/${apiPrefixDiseaseKnowledge}/lookup`,
        search: `${apiPrefix}/${apiPrefixDiseaseKnowledge}/search`
    },
    user: {
        notificationEmail: `${apiPrefix}/${apiPrefixUser}/notification_email`,
        // サポーターリスト取得
        supporterList: `${apiPrefix}/${apiPrefixUser}/supporter/list`,
    },
    utilizationDocument: {
        list: `${apiPrefix}/${apiPrefixUtilizationDocument}/list`,
        upload: `${apiPrefix}/${apiPrefixUtilizationDocument}/upload`,
        delete: `${apiPrefix}/${apiPrefixUtilizationDocument}/delete/{objectName}`
    },
    admin: {
        // サービスプロバイダーリスト取得
        serviceProviderList: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixServiceProvider}/list`,
        // サービスプロバイダー情報取得・更新
        serviceProviderInformation: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixServiceProvider}/{serviceProviderId}`,
        // サービスプロバイダー情報登録
        serviceProviderRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixServiceProvider}`,
        // ユーザーリスト取得
        userList: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixUser}/list`,
        // ユーザー情報取得
        userInformation: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixUser}/{userId}`,
        // ユーザー情報登録
        userRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixUser}`,
        // ユーザー情報更新
        userUpdate: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixUser}/{userId}`,
        // ユーザー情報削除
        userDelete: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixUser}/{userId}`,
        // 利用者リスト取得
        careRecipientList: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipient}/list`,
        // 利用者情報取得
        careRecipientInfo: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipient}/{careRecipientId}`,
        // 利用者情報更新
        careRecipientUpdate: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipient}/{careRecipientId}`,
        // 利用者情報削除
        careRecipientDelete: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipient}/{careRecipientId}`,
        // 利用者情報登録
        careRecipientRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipient}`,
        // ケアコメント登録
        careCommentRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareComment}`,
        // ケアコメント更新
        careCommentUpdate: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareComment}/{careCommentId}`,
        // ケアコメント削除
        careCommentDelete: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareComment}`,
        // 利用者メモリスト取得
        careRecipientMemoList: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipientMemo}/list`,
        // 利用者メモリスト登録
        careRecipientMemoRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipientMemo}`,
        // 利用者メモリスト更新
        careRecipientMemoUpdate: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixCareRecipientMemo}/{careRecipientMemoId}`,
        // お知らせ保存
        informationRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixInformation}`,
        // お知らせ削除
        informationDelete: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixInformation}/{informationId}`,
        // 利用者・ユーザーリスト取得
        list : `${apiPrefix}/${apiPrefixAdmin}/list`,
        // FAQ保存
        faqRegister: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixFAQ}`,
        // FAQ更新
        faqUpdate: `${apiPrefix}/${apiPrefixAdmin}/${apiPrefixFAQ}/{faqId}`,
        // 行動推定データアラート取得（全利用者データ）
        allAlert: `${apiPrefix}/${apiPrefixAdmin}/alert/list`,
        // 行動推定データアラート解除
        disableAlert: `${apiPrefix}/${apiPrefixAdmin}/alert/disable/{alertId}`,
        // 行動推定データアラート解除（複数）
        disableAlerts: `${apiPrefix}/${apiPrefixAdmin}/alert/disable_alerts`,
        // 行動推定データアラート表示切り替え
        toggleAlertDisplay: `${apiPrefix}/${apiPrefixAdmin}/alert/toggle_display/{alertId}`,
        // 平均計算月の設定・取得
        calculationMonth: `${apiPrefix}/${apiPrefixAdmin}/month/{careRecipientId}`,
        // ログイン履歴リスト取得
        loginLogList: `${apiPrefix}/${apiPrefixAdmin}/login_log`,
        // ケアコメント分析情報取得
        careCommentAnalysis: `${apiPrefix}/${apiPrefixAdmin}/care_comment_analysis`,
        // 操作ログ取得
        adminOperationLogList: `${apiPrefix}/${apiPrefixAdmin}/admin_operation_log`,
        // 問い合わせ一覧取得
        adminInquiryList: `${apiPrefix}/${apiPrefixAdmin}/inquiry`
    },
    changePassword: `${apiPrefix}/change_password`
};
